// --------------------------------------------------------------------------
// timedTicketing.js
// --------------------------------------------------------------------------
// Ticketing steps
// --------------------------------------------------------------------------

RN.timedTicketing = function() {
    'use strict';
    var modules = [
        'numberField',
        'modalContainer'
    ]
    var autosaveDelay = null;
    var mobileScreen = window.matchMedia('(max-width: 768px)');
    var okToHideLoad = true
    var loader = $('.booking-loader');
    var errorModal = $('[data-element="cart-error"]');
    var errorMessage = errorModal.find($('[data-element="cart-error-message"]'))
    var closeError = errorModal.find('[data-behaviour="cart-error-close"]')
    var delayClick = null;
    var form;
    var performanceId;
    var timeVal;
    var prettyDate;
    var selectedDate;
    var selectedTime;
    var selectedTime24;
    var body = $('body')
    var addTicketsButton = $('[data-extra-behaviour="add-tickets"]')
    var checkoutButton = $('[data-behaviour="checkout-button"]')
    var dateChanged = false
    var dateOrTimeChanged = false
    var forceDate = false

    var accordions = [];

    function init() {

        $(document).ajaxStart(function () {
            loader.show()
        }).ajaxComplete(function () {
            if (okToHideLoad) {
                loader.hide()
            }
        })

        form = byBehaviour('timed-ticketing')

        body.on('change', '.date-picker__input', getArrivalTimes);
        body.on('change', '[data-behaviour="time-option"]', getTickets);
        body.on('change', '[data-behaviour="guests-toggle"]', setCartGuests);
        body.on('click', '[data-behaviour="apply-promo-button"]', applyPromo);
        body.on('click', '[data-extra-behaviour="add-tickets"]', getPerformances);

        body.on('click', '[data-extra-behaviour="add-membership"]', addMembership);
        body.on('click', '[data-extra-behaviour="skip-membership"]', skipMembership);

        body.on('change', '[data-behaviour="addon-toggle"]', function() {
            setAddOns(true);
        });

        body.on('change', '[data-behaviour="select-membership"]', function() {
            selectMembership();
        });

        body.on('click', '[data-behaviour="checkbox-trigger"]', function() {
            var target = $(this).data('target')
            var targetInput = $('[data-behaviour="experience-toggle"][data-id="'+ target + '"]')
            targetInput.trigger('click')

            if (targetInput.is(':checked')) {
                $(this).text('Remove').addClass('button--outline-blue')
            } else {
                $(this).text('Add').removeClass('button--outline-blue')
            }
        });

        closeError.on('click', closeModal);
        errorModal.on('click', closeModal);

        function closeModal() {
            errorModal.hide();
        }

        form.on('submit', checkout);

        accordions['step-1'] = $('[data-step="1"]').parent()
        accordions['step-2'] = $('[data-step="2"]').parent()
        accordions['step-3'] = $('[data-step="3"]').parent()
        accordions['step-4'] = $('[data-step="4"]').parent()
        accordions['step-5'] = $('[data-step="5"]').parent()
        accordions['step-6'] = $('[data-step="6"]').parent()
        accordions['step-7'] = $('[data-step="7"]').parent()

        // have we seen the form before?
        // if so, kick-off the persistance

        if (form.data("forceDate") != "") {
            localStorage.clear();
            forceDate = true;
        }

        if (form.data("clear") == 1) {
            localStorage.clear();
        }
        else if (form.data("dirty") == 1) {
            setTimeout(function(){
                retrieveSession();
                // getArrivalTimes();
            }, 2000);
        }

        autoSkipMembership();
    }

    function autosave()
    {
        clearTimeout(autosaveDelay);

        autosaveDelay = setTimeout(function(){
            
            $.ajax({
                global: false,
                url: '/api/tickets/save',
                method: 'POST',
                data: form.serialize(),
                success: function (data) {
                    localStorage.setItem('selection', JSON.stringify(data.stored));
                }
            });

        }, 1000);
    }

    function applyPromo() {

        var enteredCode = $("#promoCode").val().trim();
        $("#promoCode").css({"color": "#000", "border-color": "#767676"});

        if (enteredCode == "") {
            renderErrorMessage("Please enter a code to apply to your booking");
        }
        else {

            $.ajax({
                url: '/api/tickets/promo',
                method: 'POST',
                data: {promoCode:enteredCode},
                success: function (data) {
                    renderSuccessMessage(data.message);
                    $("#promoCode").css({"color": "green", "border-color": "green"});
                },
                error: function (data) {
                    renderErrorMessage(data.responseJSON.error);
                    $("#promoCode").css({"color": "red", "border-color": "red"});
                }
            })
        }
    }

    function checkout(e){
        e.preventDefault();
        okToHideLoad = false
        $.ajax({
            url: '/api/tickets/checkout',
            method: 'POST',
            data: form.serialize(),
            success: function (data) {
                localStorage.setItem('selection', JSON.stringify(data.stored));
                document.location = data.data.url;
            },
            error: function (data) {
                okToHideLoad = true;
                renderErrorMessage(data.responseJSON.error);
            }
        })
    }

    function retrieveSession() {
        var data = null;
        var selection = null;
        var getTimes = false;
        var parsed = [];
        var selectionData = [];

        // get latest stored data
        selection = localStorage.getItem('selection');
        if (selection != null) {
            selectionData = JSON.parse(selection);

            //console.log("GOT SELECTION DATA:");
            //console.log(selectionData);

            if (selectionData.hasOwnProperty("contribution") && selectionData.contribution != "") {

                //console.log("Setting membership choice");

                $("#contribution").val(selectionData.contribution); // set value
                selectMembership();
                addMembership();

                setTimeout(function(){
                    // scroll to top of step 3
                    $('html, body').animate({
                        scrollTop: accordions['step-3'].offset().top - 20
                    }, 1000);
                }, 500);
                
            }

            if (selectionData.hasOwnProperty("selectedDate")) {
                // reset if out of date
                var now = new Date().getTime();
                if(Date.parse(selectionData.selectedDate + 'T23:59+00:00') < now) {
                    resetCart(1);
                }
                else {
                    // ensure it's selected on the calendar
                    $("#date-select-" + selectionData.selectedDate).prop("checked", true);
                    getTimes = true;
                }
            }

            // reset if we don't have a bookingType
            if (!selectionData.hasOwnProperty("bookingType")) {
                resetCart(1);
            }
            // or if it doesn't match (cross-session issue)
            else if (selectionData.bookingType != $("#bookingType").val()) {
                resetCart(1);
            }

        }

        data = localStorage.getItem('arrivalTimes');
        if (data != null) {
            getTimes = false;
            parsed = JSON.parse(data);
            parsed.stored = selectionData;
            handleArrivalTimesResponse(parsed);
        }
        data = localStorage.getItem('tickets');
        if (data != null) {
            parsed = JSON.parse(data);
            parsed.stored = selectionData;
            handleTicketsResponse(parsed);
        }
        data = localStorage.getItem('experiences');
        if (data != null) {
            parsed = JSON.parse(data);
            parsed.stored = selectionData;
            handleExperiencesResponse(parsed);
        }
        data = localStorage.getItem('showTimes');
        if (data != null) {
            parsed = JSON.parse(data);
            parsed.stored = selectionData;
            handleShowTimesResponse(parsed);
        }
        data = localStorage.getItem('moreToDo');
        if (data != null) {
            parsed = JSON.parse(data);
            parsed.stored = selectionData;
            handleMoreToDoResponse(parsed);
        }

        if (forceDate) {
            getTimes = true;
        }


        setCartDate();
        if (getTimes) {            
            getArrivalTimes();
        }
    }

    /*
    *   Step 1 -> Step 2
    */
    function getArrivalTimes() {
        var selectedDateInput = $('.date-picker__input:checked');
        if (!selectedDateInput.length) {
            return;
        }
        hideAccordions(2, 7);
        resetCart(1);
        setCartDate();

        $.ajax({
            url : '/api/tickets/step-2/' + selectedDate + '/' + performanceId + '?bookingType=' + $("#bookingType").val(),
            method: 'GET',
            success : function (data) {
                localStorage.setItem('arrivalTimes', JSON.stringify(data));
                localStorage.setItem('selection', JSON.stringify(data.stored));
                handleArrivalTimesResponse(data);
            },
            error : function (data) {
                renderErrorMessage(data.responseJSON.error);
            }
        });
    }

    function checkThisStep(step, uncheck) {
        if (uncheck) {
            // console.log("Unchecking step [" + step + "]");
            accordions['step-' + step].find('[data-element="modal-nav-button"]').removeClass('button--steps-complete')
            accordions['step-' + step].find('[data-behaviour="accordion-tick"]').removeClass('accordion__tick--active')
            accordions['step-' + step].removeClass('accordion--complete')
        } else {
            accordions['step-' + step].find('[data-element="modal-nav-button"]').addClass('button--steps-complete')
            accordions['step-' + step].find('[data-behaviour="accordion-tick"]').addClass('accordion__tick--active')
            accordions['step-' + step].addClass('accordion--complete')
        }
    }

    function nextStepCheck(step) {
        var previousStep = step - 1
        accordions['step-' + step].addClass('accordion--active').removeClass('accordion--disabled')
        accordions['step-' + previousStep].find('[data-element="modal-nav-button"]').addClass('button--steps-complete')
        accordions['step-' + previousStep].find('[data-behaviour="accordion-tick"]').addClass('accordion__tick--active')
        accordions['step-' + previousStep].addClass('accordion--complete')
    }

    function handleArrivalTimesResponse(data) {
        var times = ''
        var triggerClick = '';
        var selected = data.stored.zoneId;
        nextStepCheck(2)
        setCartDate()
        data.data.forEach(function(time) {
            var disabled = ''
            if (time.available === false) {
                disabled = 'disabled';
            }

            times += '<div class="custom-checkbox custom-checkbox--button u-mb-half"><input ';
            if (time.zoneId == selected  && !dateChanged) {
                times += 'checked="checked" ';
                triggerClick = "zone_" + selected;
            }
            times += 'data-behaviour="time-option" class="custom-checkbox__input" type="radio" id="zone_' + time.zoneId + '" ' +
                'data-time="' + time.time + '" data-time24="' + time.time24 + '" name="zoneId" value="' + time.zoneId + '"' + disabled + ' />';

            times += '<label class="custom-checkbox__label';
            if (time.available === false) {
                times += ' custom-checkbox__label--unavailable';
            }
            else if(time.soldout === true) {
                times += ' custom-checkbox__label--soldout';
            }

            times += '" for="zone_' + time.zoneId + '"><span>' + time.time;

            if (time.available === false) {
                times += '<em>Unavailable</em>';
            }
            else if(time.soldout === true) {
                times += '<em>Sold out</em>';
            }

            times += '</span></label></div>'
        })

        if (times !== '') {
            byElement('arrival-time-container').each(function(index) {
                $(this).html(times)
            })
        } else {
            byElement('arrival-time-container').each(function(index) {
                $(this).html('<p style=\'color: red\'>No times available.</p>')
            })
        }

        $('.arrivalTime').show()
        $('.arrivalTimeDesc').html(prettyDate)

        if (mobileScreen.matches) {
            $('html, body').animate({
                scrollTop: accordions['step-2'].offset().top - 20
            }, 1000);
        }

        setCartTime();

        autoSkipMembership();
    }

    /*
    *   Step 2 -> Step 3
    */
    function getTickets() {
        hideAccordions(4, 7);
        resetCart(2);
        setCartTime();

        $.ajax({
            url : '/api/tickets/step-3/' + performanceId + '/' + timeVal + '?bookingType=' + $("#bookingType").val(),
            method: 'GET',
            success : function(data) {
                localStorage.setItem('tickets', JSON.stringify(data));
                localStorage.setItem('selection', JSON.stringify(data.stored));
                handleTicketsResponse(data);
            },
            error : function (data) {
                renderErrorMessage(data.responseJSON.error);
            }
        });

    }
    /*
        This step gets "performances", i.e. steps 4 to 6 in one go
    */
    function getPerformances() {
        autosave();
        getExperiences();
        getShowTimes();
        getMoreToDo();
        // this will scroll the user down, but it's a bit of a usability issue
        // so we may remove it
        if (mobileScreen.matches) {
            $('html, body').animate({
                scrollTop: accordions['step-5'].offset().top
            }, 1000);
        }
    }


    function selectMembership() {
        var priceContainer = $("#contribution-price");
        var selected = $("#contribution").find(':selected');

        if ($(selected).val() == "") {
            $(priceContainer).hide();
        }
        else {
            $(priceContainer).find(".price").html($(selected).data("contrib-price"));
            $(priceContainer).find(".text").html($(selected).data("contrib-text"));
            $(priceContainer).show();
        }
    }

    /*
        Add membership
    */
    function addMembership() {

        //console.log("Adding membership");

        var selected = $("#contribution").val();
        if (selected == "") {
            return alert("Please select a membership type before proceeding");
        }

        autosave();
        nextStepCheck(3);

        //console.log("Next step + Setting cart membership to " + $("#contribution").find(":selected").data("pretty-name"));

        setCartMembership($("#contribution").find(":selected").data("pretty-name"));

    }

    /*
        Skip membership if we don't need it
    */
    function autoSkipMembership() {
        if (form.data("skip-membership") == 1) {
            skipMembership();
        }
    }

    /*
        Skip membership
    */
    function skipMembership() {
        $("#contribution-price").hide();
        $("#contribution").val("");
        autosave();
        nextStepCheck(3);    
        setCartMembership("--");   
        $('.cartDiscountDl').hide();
    }

    function setCartMembership(type) {
        // TODO
        $('[data-element="cartDiscount"]').html(type);
        $('.cartDiscountDl').show();
    }

    /*
        Step 4
    */
    function getExperiences() {

        $.ajax({
            url : '/api/tickets/step-4/' + selectedDate + '?bookingType=' + $("#bookingType").val(),
            method: 'GET',
            success : function (data) {
                localStorage.setItem('experiences', JSON.stringify(data));
                localStorage.setItem('selection', JSON.stringify(data.stored));
                handleExperiencesResponse(data);
            },
            error : function (data) {
                renderErrorMessage(data.responseJSON.error);
            }
        });
    }

    /*
        Step 5
    */
    function getShowTimes() {
        $.ajax({
            url : '/api/tickets/step-5/' + selectedDate + '?bookingType=' + $("#bookingType").val(),
            method: 'GET',
            success : function (data) {
                localStorage.setItem('showTimes', JSON.stringify(data));
                localStorage.setItem('selection', JSON.stringify(data.stored));
                handleShowTimesResponse(data);
            },
            error : function (data) {
                renderErrorMessage(data.responseJSON.error);
            }
        });
    }

    /*
        Step 6
    */
    function getMoreToDo() {
        $.ajax({
            url : '/api/tickets/step-6/' + selectedDate + '?bookingType=' + $("#bookingType").val(),
            method: 'GET',
            success : function (data) {
                localStorage.setItem('moreToDo', JSON.stringify(data));
                localStorage.setItem('selection', JSON.stringify(data.stored));
                handleMoreToDoResponse(data);
            },
            error : function (data) {
                renderErrorMessage(data.responseJSON.error);
            }
        });
    }

    function handleTicketsResponse(data) {
        var advance = false;
        var tickets = ''
        var ticketTypeContainer = byBehaviour('ticket-type-container')
        nextStepCheck(3)
        nextStepCheck(4)

        data.data.forEach(function(ticket) {

            var value = data.stored.ticketType ? data.stored.ticketType[ticket.priceTypeId] : 0;
            if (value != 0) {
                advance = true;
            }
            else {
                value = 0;
            }
            if (dateOrTimeChanged) {
                value = 0
            }
            tickets += '<div class="grid__item">' +
                '<div data-element="price-' + ticket.priceTypeId + '" class="ticket-type ticket-type--number-input">' +
                    '<div class="ticket-type__header">' +
                        '<h3 class="ticket-type__title">' + ticket.priceName +
                            '<span class="ticket-type__description">'+ ticket.priceAge + '</span>' +
                        '</h3>' +
                        '<ul class="ticket-type__price-list">';

                            if (ticket.showRRP) {
                                tickets += '<li class="ticket-type__price ticket-type__original-price">$' + ticket.priceRRP + '</li>';
                                tickets += '<li class="ticket-type__price">Member-Only Price: $' + ticket.price + '</li>';
                            }
                            else {
                                tickets += '<li class="ticket-type__price">$' + ticket.price + ' per guest</li>';
                            }

                tickets += '</ul>' +
                    '</div>' +
                    '<div class="ticket-type__main">' +
                        '<p data-element="total-price" class="ticket-type__summary"></p>' +
                        '<div class="ticket-type__select ticket-type__select--no-after">' +
                            '<div class="number-field number-field--block-center number-field--small" data-behaviour="number-field">' +
                                '<button class="number-field__button number-field__button--decrease" data-element="decrease">Decrease by 1</button>' +
                                '<input class="number-field__input" type="text" data-behaviour="guests-toggle" data-price="' + ticket.price + '" ' +
                                'data-price-name="' + ticket.priceName + '" name="ticketType[' + ticket.priceTypeId + ']" value="' + value + '" data-element="input" data-min="0" data-max="10" autocomplete="off"/>' +
                                '<button class="number-field__button number-field__button--increase" data-element="increase">Increase by 1</button>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</div>'

            if (tickets !== '') {
                ticketTypeContainer.html(tickets)
            } else {
                ticketTypeContainer.html('<p style=\'color: red\'>No tickets available.</p>')
            }

            setCartGuests();
        })

        if (mobileScreen.matches) {
            $('html, body').animate({
                scrollTop: accordions['step-3'].offset().top - 20
            }, 1000);
        }

        reInitModules()
    }


    function handleExperiencesResponse(response) {
        var experiencesContainer = byBehaviour('experiences-container')
        var exhibitions = ''
        nextStepCheck(5)
        response.data.forEach(function(exhibition) {

            exhibitions += RN['performanceCard'].init(exhibition, selectedTime24, response, dateOrTimeChanged)

            /*var selected = response.stored.experiences ? response.stored.experiences.includes(exhibition.performanceId.toString()) : false;
            if (dateOrTimeChanged) {
                selected = false
            }
            exhibitions += RN['performanceCard'].init(exhibition, selected)*/

        })

        if (exhibitions !== '') {
            experiencesContainer.html(exhibitions)
            setTimeout(function(){
                setShowTimes(false);
            }, 500);

            uncheckableTimes();

        } else {
            experiencesContainer.html('<p style="color: red">Please continue to the next step.</p>')
        }
        reInitModules()
    }

    function handleShowTimesResponse(response) {
        var showTimesContainer = byBehaviour('showtimes-container')
        var shows = ''
        nextStepCheck(6)
        response.data.forEach(function(show) {
            shows += RN['showCard'].init(show, selectedTime24, response, dateOrTimeChanged)

        })

        if (shows !== '') {
            showTimesContainer.html(shows);

            setTimeout(function(){
                setShowTimes(false);
            }, 500);

            uncheckableTimes();

        } else {
            showTimesContainer.html('<p style=\'color: red\'>Please continue to the next step.</p>')
        }
        reInitModules()
    }

    function handleMoreToDoResponse(response) {
        var extrasContainer = byBehaviour('addons-container')
        var extras = ''
        nextStepCheck(7)

        response.data.forEach(function(extra) {
            var priceRRP = ''
            if (extra.showRRP) {
                priceRRP = '<span class="performance-card__original-price">$' + extra.priceRRP + '</span> ';
            }
            var quantity = response.stored.addOns ? (response.stored.addOns[extra.performanceId_zoneId_priceTypeId] ? response.stored.addOns[extra.performanceId_zoneId_priceTypeId] : 0) : 0;
            if (dateOrTimeChanged) {
                quantity = 0
            }

            var modalMarkup = '<aside class="modal-desktop modal-desktop--with-image" data-element="show-' + extra.performanceId  + '-info" data-class="modal-desktop--active">' +
                '<div class="modal-desktop__bg" data-behaviour="modal-trigger" data-target="show-' + extra.performanceId  + '-info"></div>' +
                '<div class="modal-desktop__body">' +
                    '<div class="modal-desktop__header">' +
                        '<button type="button" class="modal-desktop__close" data-behaviour="modal-trigger" data-target="show-' + extra.performanceId  + '-info">' +
                            '<span class="sr-only">close modal</span>' +
                        '</button>' +
                    '</div>' +
                    '<div class="modal-desktop__container modal-desktop__container--has-fixed-button-container">' +
                        '<div class="u-pr-30 u-pb u-pl-30">' +
                            '<p class="performance-card__heading">' + extra.cmsData.modalTitle + '</p>' +
                            '<p class="performance-card__desc u-mb0 u-pb">' + extra.cmsData.modalDescription + '</p>';

                    if (extra.cmsData.youtubeId != "") {       
                        modalMarkup += '<div class="youtubeBlock youtubeBlockResponsive16by9">' +
                                '<iframe class="youtube-player" src="//www.youtube.com/embed/' + extra.cmsData.youtubeId + '?color=red&controls=1&hl=en&iv_load_policy=1&modestbranding=1&rel=0&showinfo=1" frameborder="0" allowfullscreen></iframe>' +
                            '</div>';
                    }
                    else if (extra.cmsData.modalImage != "") {
                        modalMarkup += '<img src="' + extra.cmsData.modalImage + '" class="modal-desktop__img" />';
                    }

                    modalMarkup += '</div>' +
                    '</div>' +
                '</div>' +
            '</aside>';

            // removed modal from grid__item
            /*
            '<div data-behaviour="modal-container">'+
                '<button class="button button--text-icon u-mb-30" data-behaviour="modal-trigger" data-target="show-' + extra.performanceId  + '-info" type="button">More Info' +
                    '<svg class="button__icon" role="presentation"><use xlink:href="#icon-chevron-circle"></use></svg>' +
                '</button>' +
                modalMarkup +
            '</div>'+
            */

            extras += '<div class="grid__item">' +
                '<article class="performance-card">' +
                    '<img class="performance-card__image" src="' + extra.cmsData.thumbnail + '" />' +
                    '<div class="performance-card__content">' +
                        '<h1 class="performance-card__heading">' + extra.name + '</h1>' +
                        '<p class="performance-card__desc u-mb">' + extra.description + '</p>' +
                        '<div class="performance-card__price-container">' +
                            '<p class="performance-card__price">' +
                            priceRRP +
                            '$' + extra.price + ' per guest</p>' +
                        '</div>' +
                        '<hr class="hr" />' +
                        '<div class="ticket-type__select ticket-type__select--no-after u-mt">' +
                            '<div class="number-field number-field--small number-field--block-center" data-behaviour="number-field">' +
                                '<button class="number-field__button number-field__button--decrease" data-element="decrease">Decrease by 1</button>' +
                                '<input class="number-field__input" data-behaviour="addon-toggle" type="text" data-price-name="' + extra.name + ' (' + extra.description + ')" name="addOns[' + extra.performanceId_zoneId_priceTypeId + ']" ' +
                                'value="' + quantity + '" data-element="input" data-min="0" data-max="10"/>' +
                                '<button class="number-field__button number-field__button--increase" data-element="increase">Increase by 1</button>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                '</article>' +
            '</div>'
        })

        if (extras !== '') {
            extrasContainer.closest("[data-element='accordion']").show();
            extrasContainer.show();
            extrasContainer.html(extras)
        } else {
            extrasContainer.closest("[data-element='accordion']").hide();
            extrasContainer.hide();
            extrasContainer.html('<p style=\'color: red\'>All of LSC\'s permanent exhibitions are included with your admission. Please proceed to checkout.</p>')
        }

        setTimeout(function(){
            setAddOns(false);
        }, 500);

        reInitModules()
    }

    function renderErrorMessage(message) {
        loader.hide()
        errorMessage.css("color", "#E9263A");
        errorMessage.text(message);
        errorModal.show();
    }

    function renderSuccessMessage(message) {
        loader.hide()
        errorMessage.css("color", "green");
        errorMessage.text(message);
        errorModal.show();
    }

    function hideAccordions(from, to)
    {
        for(var i = from; i <= to; i++) {
            // console.log("Hiding step [" + i + "]");
            accordions['step-' + i].removeClass('accordion--active').addClass('accordion--disabled')
        }
    }

    function resetCart(step) {
        if (step === 1) {
            dateChanged = true
            dateOrTimeChanged = true
            localStorage.clear()

            $('[data-element="cartTime"]').html("--");
            $('[data-element="cartDiscount"]').html("--");
            $('.cartDiscountDl').hide();

            $('[data-behaviour="accordion-tick"]').each(function(){
                $(this).removeClass('accordion__tick--active')
            })
            $('[data-element="modal-nav-button"]').each(function(){
                $(this).removeClass('button--steps-complete')
            })

        }
        if (step === 2) {
            // dateOrTimeChanged = true
            localStorage.removeItem('tickets');
            localStorage.removeItem('experiences');
            localStorage.removeItem('showTimes');
            localStorage.removeItem('moreToDo');
        }

            
        // always clear the following
        $('[data-element="cartGuests"]').html("--");
        $('[data-element="cartShowTimes"]').html("--");
        $('[data-element="cartExperiences"]').html("--");
        $('[data-element="cartAddOns"]').html("--");

        // clear elements
        var experiencesContainer = byBehaviour('experiences-container');
        experiencesContainer.html("");

        var showTimesContainer = byBehaviour('showtimes-container');
        showTimesContainer.html("");

        var extrasContainer = byBehaviour('addons-container');
        extrasContainer.html("");

    }

    function setCartDate() {
        var selectedDateInput = $('.date-picker__input:checked');
        if (!selectedDateInput.length) {
            return;
        }

        selectedDate = selectedDateInput.data('date')
        prettyDate = selectedDateInput.data('pretty-date')
        performanceId = selectedDateInput.val()

        $('[data-element="cartDate"]').html(prettyDate);
    }

    function setCartGuests() {

        var cartGuests = [];
        $('[data-behaviour="ticket-type-container"] [data-element="input"]').each(function(){

            var totalPriceLabel = $(this).parent().parent().parent().find('[data-element="total-price"]');
            if($(this).val() > 0) {
                // show the price
                var roundedPrice = (parseFloat($(this).data("price")) * parseInt($(this).val())).toFixed(2)
                totalPriceLabel.html("$" + roundedPrice);
                cartGuests.push("x" + $(this).val() + " " + $(this).data("price-name"));
            }
            else {
                totalPriceLabel.html("");
            }
        });

        if(cartGuests.length > 0) {
            checkThisStep(4)
            addTicketsButton.prop('disabled', false)
            checkoutButton.prop('disabled', false)
            $('[data-element="cartGuests"]').html(cartGuests.join(", "));
        }

        else {
            checkThisStep(4, true)
            addTicketsButton.prop('disabled', true)
            checkoutButton.prop('disabled', true)
            $('[data-element="cartGuests"]').html("--");
        }
    }

    function setCartTime() {
        var selected = $('[data-behaviour="time-option"]:checked');
        if (!selected.length) {
            return;
        }

        timeVal = selected.val()
        selectedTime = selected.data('time')
        selectedTime24 = selected.data('time24')

        $('[data-element="cartTime"]').html(selectedTime);
    }

    /*
        This sets the show times in the side cart
    */
    function setShowTimes(clicked) {

        if(clicked) {
            autosave();
        }

        var cartExperienceTimes = [];
        var cartShowTimes = [];
        var timeSelectedCompare;
        var duration = 0;
        var ignoreConflictsA = 0;
        var ignoreConflictsB = 0;

        // reset
        // console.log("RESETTING ALL AVAILABLE SHOWTIMES TO AVAILABLE");

        $('[data-behaviour="showtime-toggle"]').removeAttr("disabled");
        $('[data-behaviour="showtime-toggle"]').next('label').css("opacity", 1);

        // run through selected premium and add to array / disable close ones
        $('[data-behaviour="experiences-container"] [data-behaviour="showtime-toggle"]').each(function(){
            if($(this).is(':checked')) {

                //console.log($(this).data("datetime") + " is CHECKED?");

                cartExperienceTimes.push({datetime: $(this).data("datetime"), time: $(this).data("time24"), label: $(this).data("time") + "<br>" + $(this).data("name")});

                timeSelectedCompare = Date.parse($(this).data("datetime"));
                duration = (parseInt($(this).data("duration")) * 60000); // e.g. 30 mins
                ignoreConflictsA = parseInt($(this).data("ignore-conflicts"));


                // console.log("Ex Clicked Parent[" + ignoreConflictsA + "]");


                // disable any same-time
                $('[data-behaviour="showtime-toggle"]').not(this).each(function(){
                    var timeCompareTo = Date.parse($(this).data("datetime"));
                    var ignoreConflictsB = $(this).data("ignore-conflicts");

                    // console.log("Child[" + ignoreConflictsB + "]");

                    var tmp_dateSelected = new Date(timeSelectedCompare);
                    var tmp_dateCompareToA = new Date(timeCompareTo - duration);
                    var tmp_dateCompareToB = new Date(timeCompareTo + duration);
                    console.log("IF " + tmp_dateSelected.toUTCString() + " >= " + tmp_dateCompareToA.toUTCString() + " && " + tmp_dateSelected.toUTCString() + " <= " + tmp_dateCompareToB.toUTCString());

                    if (ignoreConflictsA == 1 || ignoreConflictsB == 1) {
                        console.log("Ignoring because of time conflicts being allowed");
                    }
                    else if (timeSelectedCompare >= (timeCompareTo - duration) && timeSelectedCompare <= (timeCompareTo + duration)) {

                        console.log("DISABLING 1 - " + timeCompareTo);
                        $(this).attr("disabled", "disabled");
                        $(this).parent().find("label").css("opacity", 0.3);
                    }

                });


            }
        });

        // run through selected times and add to array / disable close ones
        $('[data-behaviour="showtimes-container"] [data-behaviour="showtime-toggle"]').each(function(){
            if($(this).is(':checked')) {
                
                //console.log($(this).data("datetime") + " is CHECKED?");

                cartShowTimes.push({datetime: $(this).data("datetime"), time: $(this).data("time24"), label: $(this).data("time") + "<br>" + $(this).data("name")});

                timeSelectedCompare = Date.parse($(this).data("datetime"));

                //console.log("PARSED GIVES [" + timeSelectedCompare + "]");
                //var tmp_dateSelected = new Date(timeSelectedCompare);
                //console.log("RE-DATED GIVES [" + tmp_dateSelected.toUTCString() + "]");


                duration = (parseInt($(this).data("duration")) * 60000); // e.g. 30 mins
                ignoreConflictsA = parseInt($(this).data("ignore-conflicts"));
                // console.log("Show Clicked Parent[" + ignoreConflictsA + "]");

                // disable any same-time
                $('[data-behaviour="showtime-toggle"]').not(this).each(function(){
                    var timeCompareTo = Date.parse($(this).data("datetime"));
                    var ignoreConflictsB = $(this).data("ignore-conflicts");

                    // console.log("Child[" + ignoreConflictsB + "]");

                    var tmp_dateSelected = new Date(timeSelectedCompare);
                    var tmp_dateCompareTo = new Date(timeCompareTo);
                    var tmp_dateCompareToA = new Date(timeCompareTo - duration);
                    var tmp_dateCompareToB = new Date(timeCompareTo + duration);

                    console.log("IF " + tmp_dateSelected.toUTCString() + " >= " + tmp_dateCompareToA.toUTCString() + " && " + tmp_dateSelected.toUTCString() + " <= " + tmp_dateCompareToB.toUTCString());
                    
                    if (ignoreConflictsA == 1 || ignoreConflictsB == 1) {
                        console.log("Ignoring because of time conflicts being allowed");
                    }
                    else if (timeSelectedCompare >= (timeCompareTo - duration) && timeSelectedCompare <= (timeCompareTo + duration)) {

                        console.log("DISABLING 2 - " + tmp_dateCompareTo.toUTCString());
                        $(this).attr("disabled", "disabled");
                        $(this).parent().find("label").css("opacity", 0.3);
                    }

                });


            }
        });

        if(cartExperienceTimes.length > 0) {
            checkThisStep(5)

            // sort show times by time
            cartExperienceTimes.sort(function(a, b) {
              var keyA = Date.parse(a.datetime), keyB = Date.parse(b.datetime);
              if (keyA < keyB) return -1;
              if (keyA > keyB) return 1;
              return 0;
            });

            // join labels together
            var html = cartExperienceTimes.map(function(elem){
                return elem.label;
            }).join('<hr class="hr hr--spaced" />');

            $('[data-element="cartExperiences"]').html(html);
        } else {
            checkThisStep(5, true)
            $('[data-element="cartExperiences"]').html("--");
        }

        if(cartShowTimes.length > 0) {
            checkThisStep(6)

            // sort show times by time
            cartShowTimes.sort(function(a, b) {
              var keyA = Date.parse(a.datetime), keyB = Date.parse(b.datetime);
              if (keyA < keyB) return -1;
              if (keyA > keyB) return 1;
              return 0;
            });

            // join labels together
            var html = cartShowTimes.map(function(elem){
                return elem.label;
            }).join('<hr class="hr hr--spaced" />');

            $('[data-element="cartShowTimes"]').html(html);
        } else {
            checkThisStep(6, true)
            $('[data-element="cartShowTimes"]').html("--");
        }
    }

    /*
        This sets the add ons in the side cart
    */
    function setAddOns(clicked) {

        if(clicked) {
            autosave();
        }

        var cartAddOns = [];
        $('[data-behaviour="addons-container"] [data-element="input"]').each(function(){
            if($(this).val() > 0) {
                // 2 x Drinks
                cartAddOns.push("x" + $(this).val() + " " + $(this).data("price-name"));
            }
        });

        if(cartAddOns.length > 0) {
            checkThisStep(7)
            $('[data-element="cartAddOns"]').html(cartAddOns.join(", "));
        }
        else {
            checkThisStep(7, true)
            $('[data-element="cartAddOns"]').html("--");
        }
    }

    function reInitModules() {
        for(var i = 0; i < modules.length; i++) {
            RN[modules[i]].init();
        }
    }

    function uncheckableTimes()
    {
        $('[data-behaviour="showtime-toggle"]').each(function () {
            var radio = this;
            $('label[for="' + radio.id + '"]').add(radio).mousedown(function () {
                $(radio).data('wasChecked', radio.checked);
                setShowTimes(true);
            });

            $('label[for="' + radio.id + '"]').add(radio).click(function () {
                if ($(radio).data('wasChecked'))
                    radio.checked = false;

                setShowTimes(true);
            });
        });
    }


    return {
      init: init
    };

}();
